import { createContext } from 'react';
import { decorateName } from "./utils.js";
export var UnmappedContext = decorateName( /*#__PURE__*/createContext(null), 'UnmappedContext');
export default UnmappedContext;
//# sourceMappingURL=UnmappedContext.js.map